import { StyledCol } from '../ContainerLookupStyles';

export const ValueCol = ({
  value,
  children,
  span,
  isDate,
  style,
}: {
  value?: string;
  span?: number;
  children?: any;
  isDate?: Boolean;
  style?: any;
}) => {
  span = span || 17;
  if (!value && !children && isDate) value = 'Pending';
  if (!style) style = {};
  else if (value && /^\s*$/.test(value)) value = 'Pending';
  else if (isDate && value) {
    // Convert to "D/M/YYY HH:MM"
    value = value.includes(':')
      ? new Date(value).toLocaleString('en-US', { timeZone: 'Etc/GMT+5' })
      : new Date(value.trim()).toLocaleDateString('en-US', { timeZone: 'UTC' });
  }
  return (
    <StyledCol span={span} color={'primary'} style={style}>
      {value || children}
    </StyledCol>
  );
};
